import { render } from "./ReadonlyTextarea.vue?vue&type=template&id=32e39734&scoped=true"
import script from "./ReadonlyTextarea.vue?vue&type=script&lang=js"
export * from "./ReadonlyTextarea.vue?vue&type=script&lang=js"

import "./ReadonlyTextarea.vue?vue&type=style&index=0&id=32e39734&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e39734"]])

export default __exports__